import { LEGACY_SPONSOR_SLUGS, REDIRECTS, ROUTES } from '@/constants';

export function createPageUrl(pageName: string) {
	return '/' + pageName.replace(/ /g, '-');
}

/** Where a legacy path (old PascalCase pages, pre-/sponsor short links) lives now, or null. */
export function getLegacyRedirectPath(pathname: string): string | null {
	const redirect = REDIRECTS[pathname as keyof typeof REDIRECTS];
	if (redirect) return redirect;
	const slug = pathname.substring(1);
	return LEGACY_SPONSOR_SLUGS.includes(slug) ? `${ROUTES.SPONSOR}/${slug}` : null;
}
